<template>
	<el-container class="el-container" >
	    <el-aside style="background-color: #447FE3;border-top-right-radius: 30px;" :width="isCollapse ? '64px' : '200px'" class="el-aside-container"> <!-- :default-active="activeIndex" -->
			<div class="toggle-logo" @click="collapseMenu">
				<el-image style="width: 60px; height: 60px;border-radius: 30px;" :src="leftlogourl" ></el-image>
				<p v-show="!isCollapse">理想美食城</p>
			</div>
			<!-- <div class="toggle-button" @click="collapseMenu">
				<i size="20" :class="menucollapicon"></i>
			</div> -->
			<el-menu style="border-right: none !important;" @select="menuSelected"  :router="true" class="el-menu-container" background-color="#447FE3" text-color="#fff"
				@open="handleOpen" @close="handleClose" :collapse="isCollapse">
				<div v-for="(item) in menus" :key="item.id">
					<el-menu-item v-if="item.submenu == undefined || item.submenu == null || item.submenu.length == 0 " :index="item.id">
						<i :class="item.icon"></i>
						<span slot="title">{{item.name}}</span>
					</el-menu-item>
					<el-submenu v-else :index="item.id">
						<template slot="title">
							<i :class="item.icon"></i>
							<span v-show="!isCollapse" slot="title">{{item.name}}</span>
						</template>
						<el-menu-item-group v-for="(submenu,subidx) in item.submenu" :key="subidx">
							<el-menu-item :index="submenu.id">{{submenu.name}}</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
				</div> 
			</el-menu>	
		</el-aside>
		<div :style="{width : isCollapse ? 'calc( 100% - 64px)' : 'calc( 100% - 200px)', float : 'right'}">
			<SysHeader></SysHeader>
			<router-view />
		</div>
	</el-container>
</template>

<script>
	import SysHeader from '../home/header' 
	export default {
		name : 'MenuList',
		data() {
			return {
				leftlogourl : "logo.png",
				//activeIndex: this.$route.path,
				bgcolor : '#FFF  !important',
				menucollapicon : 'el-icon-d-arrow-left',
				isCollapse: false,
				menus : [
					{
						id : 'CouponMan',
						name: '优惠劵管理',
						url : 'CouponMan',
						icon: 'el-icon-s-ticket yh-menu-icon-color',
						submenu : [
							{
								id : 'CouponsMng',
								name : '优惠劵管理',
								url: 'CouponsMng',
							},
							{
								id : 'CustomerCouponList',
								name : '客户优惠券',
								url: 'customercouponlist',
							},
						]
					},
					{
						id : 'OrderMan',
						name: '订单管理',
						icon: 'el-icon-s-order yh-menu-icon-color',
						submenu : [
							{
								id : 'TodayOrders',
								name : '历史订单',
								url: 'TodayOrders',
							},
							{
								id : 'RefundOrderList',
								name : '退款管理',
								url: 'refundorderlist',
							},
						]
					},
					{
						id : 'ReportMan',
						name: '报表统计',
						icon: 'el-icon-s-marketing yh-menu-icon-color',
						submenu : [
							{
								id : 'OrderSaleList',
								name : '平台销售统计',
								url: 'ordersalelist',
							},
							{
								id : 'DeliveryDetail',
								name : '配送员统计',
								url: 'deliverydetail',
							},
						]
					},
					{
						id : 'SysMan',
						name: '系统维护',
						icon: 'el-icon-setting yh-menu-icon-color',
						submenu : [
							{
								id : 'BusinessList',
								name : '商家管理',
								url: 'businesslist',
							},
							{
								id : 'StallList',
								name : '档口管理',
								url: 'stalllist',
							},
							{
								id : 'ShopUserList',
								name : '商家用户管理',
								url: 'shopuserlist',
							},
							{
								id : 'SysConfigList',
								name : '系统配置',
								url: 'sysconfiglist',
							},
							{
								id : 'CabsList',
								name : '外卖柜管理',
								url: 'cabslist',
							}
						]
					},
				],
				
			}
		},
		mounted() {
			console.log('menu')
		},
		components: {
			SysHeader
		},
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			menuSelected(key,path){
				console.log(key,path)
				//this.$emit('menuSelect',key)
			},
			collapseMenu(){
				if(this.isCollapse){
					this.isCollapse = false
					this.menucollapicon = 'el-icon-d-arrow-left'
				}else{
					this.isCollapse = true
					this.menucollapicon = 'el-icon-d-arrow-right'
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	/* body {
		background-color: var(bgcolor);
	} */
	.el-container {
		height: 100%;
		.el-aside-container {
			height: 100%;
			border-top-right-radius: 30px;
			background-color: '#447FE3';
			.el-menu-container {
				height: 100%;
				min-height: 800px;
				color: #fff !important;  
			}
		}
	}
	/* .el-menu-vertical-demo:not(.el-menu--collapse) {
	    width: 200px;
	    min-height: 800px;
		color: #fff !important;  
	} */
	.yh-menu-icon-color{
		color: #fff;
	}
	.el-submenu__title i {
	    color: #fff !important;
	}
	.toggle-button{
		font-size: 14px;
		color: #fff;
		text-align: center;
	}
	.toggle-logo{
		font-size: 14px;
		color: #fff;
		margin-top: 10px;
		border-top-right-radius: 10px;
		text-align: center;
		border-bottom: 1px solid #f1f1ff;
	}
	
</style>